import React from "react";
import { Button, LongTextLabel } from "@sscs/ui";
import { getClassName } from "@sscs/utils";
import { getNameFromSignatureProperties } from "../../../../utils";
import CertificateIcon from "../certificateIcon/CertificateIcon";
import { convertToShortValidationResult } from "../utils";
import styles from "./certificateButton.module.scss";
const CertificateButton = ({ certificateId, subject, validationResults, isActive, onClick, }) => {
    const shortResults = new Set();
    // No validation results, certificate is valid
    if (validationResults.results.length === 0) {
        shortResults.add("Valid");
    }
    else {
        validationResults.results.forEach((result) => {
            shortResults.add(convertToShortValidationResult(result));
        });
    }
    return (React.createElement(Button, { id: certificateId, color: "secondary", disabled: isActive, onClick: () => onClick(certificateId), className: getClassName(styles["certificate-button"], {
            [styles["active-certificate"]]: isActive,
        }) },
        React.createElement(CertificateIcon, { validationResults: validationResults.results }),
        React.createElement("div", { className: styles.subject },
            React.createElement(LongTextLabel, { label: subject ? getNameFromSignatureProperties(subject) : "Unknown" }),
            React.createElement("div", { className: styles["validation-results"] }, Array.from(shortResults).map((result) => (React.createElement("small", { key: result, className: styles["validation-result"] }, result)))))));
};
export default CertificateButton;
//# sourceMappingURL=CertificateButton.js.map